import {DraggableTree} from 'vue-draggable-nested-tree'
import { mapGetters } from 'vuex'

export default {
  name: 'import',
  components: {
    Tree: DraggableTree,
  },
  props: ['data'],
  data () {
    return {
      errors: {},
      btn_submit: false,
      file: [],
      doc_item: []
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    changeFile (even) {
      for (var i = 0; i < this.$refs.files.files.length; i++) {
        this.file.push(this.$refs.files.files[i])
        let reader = new FileReader()
        reader.onload = (event) => {
          // console.log(event)
          // this.preview.push(event.target.result)
        }
        reader.readAsDataURL(this.$refs.files.files[i])
      }
    },

    showForm () {
      this.$refs.importForm.show()
    },

    view () {
      this.$router.push(this.$route.params.document_id + '/view')
    },


    importFile () {
      var file = new FormData()
      file.append('file', this.file[0])
    
      this.$emit('loading', true)
      this.$store.dispatch('DocumentItem/importDocumentItem', {document: {id: this.$route.params.document_id}, file}).then(res => {
        this.$emit('loading', false)
        this.$refs.importForm.hide()
        
        this.$notify({
          group: 'success',
          title: 'Vui lòng chờ',
          text: 'Đang tải lên tệp của bạn !'
        })
      }).catch(errors => {
        this.$emit('loading', false)
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/document-item/import/import.js